import React, { FC, useRef } from "react";
import type { LatestNewsProps } from "@/types";
import { Link } from "../link";
import { useInView } from "@/hooks/reveal-in-view";
import SplitTextAnimation from "../split-text-animation";

export const LatestNews: FC<LatestNewsProps> = ({ title, viewAll, posts }) => {
  const formatDate = (date: string) => {
    const dateObj = new Date(date);
    const month = dateObj.toLocaleString("default", { month: "long" });
    const day = dateObj.getDate();

    return `${month} ${day}`;
  };
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section className="latestNews">
      <div className="wrapper">
        <div className="latestNews--top">
          <SplitTextAnimation
            htmlElement={<h2 className="latestNews--title">{title}</h2>}
            isInView={isInView}
          />
          {viewAll.link?.uri && (
            <Link
              href={viewAll.link?.uri}
              noStyle
              className="latestNews--viewAll"
            >
              {viewAll.text}
            </Link>
          )}
        </div>
        <div className="latestNews--results" ref={ref}>
          {posts.map((post, index) => {
            return (
              <Link
                key={index}
                href={`/resources/${post.group}/${post.slug}`}
                noStyle
                className="latestNews--result"
                style={{
                  transform: isInView
                    ? "none"
                    : `translateY(${20 * (index + 1)}px)`,
                  opacity: isInView ? 1 : 0,
                  transition: `all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1) ${
                    index * 0.1
                  }s`,
                }}
              >
                <div className="latestNews--result-details">
                  <div className="latestNews--result-date">
                    {formatDate(post.date)}
                  </div>
                  {post.type && (
                    <div className="latestNews--result-tag">{post.type}</div>
                  )}
                </div>
                <h3 className="latestNews--result-title">{post.title}</h3>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
